import { IStore } from '..';
import { TAutomatedCallReducerState } from '../../app/types/automated-call-types';

export const getAutomatedCallData = (
  state: IStore
): TAutomatedCallReducerState => state.automatedCallReducer;
